import { render, staticRenderFns } from "./CompanyUpdateUserAccess.vue?vue&type=template&id=f7eebfa6"
import script from "./CompanyUpdateUserAccess.vue?vue&type=script&lang=js"
export * from "./CompanyUpdateUserAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7eebfa6')) {
      api.createRecord('f7eebfa6', component.options)
    } else {
      api.reload('f7eebfa6', component.options)
    }
    module.hot.accept("./CompanyUpdateUserAccess.vue?vue&type=template&id=f7eebfa6", function () {
      api.rerender('f7eebfa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/CompanyUpdateUserAccess.vue"
export default component.exports